import React from 'react'
import { BrowserRouter as Router, Switch, Route } from 'react-router-dom'
import { NotificationProvider, ToastConsumer } from '@livechat/design-system'
import './index.css'
import Main from './views/Main'
import Connection from './views/Connection'

const App = () => {
  return (
    <NotificationProvider>
      <ToastConsumer horizontalPosition="center" fixed verticalPosition="top" />
      <Router>
        <Switch>
          <Route exact path="/">
            <Main />
          </Route>

          <Route path="/connected">
            <Connection />
          </Route>
        </Switch>
      </Router>
    </NotificationProvider>
  )
}

export default App
